import React from 'react'
import { CButton, CCard, CCardBody, CCardHeader } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilCalendarCheck, cilLifeRing } from '@coreui/icons'

const NeedHelpCard = () => (
  <CCard className="mb-4">
    <CCardHeader>Need Help?</CCardHeader>
    <CCardBody>
      <p className="text-medium-emphasis">
        Visit our Help Center or book an intro session with our team.
      </p>
      <CButton
        color="danger"
        variant="outline"
        className="me-2"
        onClick={() => window.open('https://myclubtap.tawk.help/', '_blank')}
      >
        <CIcon icon={cilLifeRing} className="me-1" /> Help
      </CButton>
      <CButton
        color="primary"
        variant="outline"
        onClick={() =>
          window.open(
            'https://calendly.com/vickyatmyclubtap/myclubtapintroforgameadminsin30mins?back=1',
            '_blank',
          )
        }
      >
        <CIcon icon={cilCalendarCheck} className="me-1" /> Book Session
      </CButton>
    </CCardBody>
  </CCard>
)

export default NeedHelpCard
